// src/api/authApi.js
// ✅ Usa STORAGE_KEYS con namespace
// ✅ ApiError invece di ApiErrorHandler
// ✅ Gestione refresh token separata

import axiosConfig from './axiosConfig';
import { ApiError } from '../utils/apiErrorHandler';
import { STORAGE_KEYS } from '../utils/constants';

export const authApi = {

  register: async (userData) => {
    try {
      const response = await axiosConfig.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      throw new ApiError(error, 'register');
    }
  },

  login: async (credentials) => {
    try {
      const response = await axiosConfig.post('/auth/login', credentials);
      const { token, refreshToken, user } = response.data.data;

      if (token) {
        localStorage.setItem(STORAGE_KEYS.TOKEN, token);
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken || '');
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
      }

      return response.data;
    } catch (error) {
      throw new ApiError(error, 'login');
    }
  },

  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  },

  getMe: async () => {
    try {
      const response = await axiosConfig.get('/auth/me');
      return response.data;
    } catch (error) {
      throw new ApiError(error, 'getMe');
    }
  },

  refreshToken: async () => {
    try {
      const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN);
      if (!refreshToken) throw new Error('Nessun refresh token disponibile');

      const response = await axiosConfig.post('/auth/refresh-token', { refreshToken });
      const { token, refreshToken: newRefresh } = response.data.data;

      if (token) {
        localStorage.setItem(STORAGE_KEYS.TOKEN, token);
        if (newRefresh) localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, newRefresh);
      }

      return response.data;
    } catch (error) {
      throw new ApiError(error, 'refreshToken');
    }
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    try {
      const response = await axiosConfig.post('/users/change-password', {
        currentPassword,
        newPassword,
      });
      return response.data;
    } catch (error) {
      throw new ApiError(error, 'changePassword');
    }
  },

  updateProfile: async (data) => {
    try {
      const response = await axiosConfig.put('/auth/profile', data);
      // Aggiorna utente in localStorage
      const stored = localStorage.getItem(STORAGE_KEYS.USER);
      if (stored) {
        const user = JSON.parse(stored);
        localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify({ ...user, ...response.data.data }));
      }
      return response.data;
    } catch (error) {
      throw new ApiError(error, 'updateProfile');
    }
  },
};